import { Link } from "wouter";
import { useT } from "@/i18n";

export function Footer() {
  const t = useT();
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-border bg-background">
      <div className="mx-auto max-w-7xl px-4 md:px-8 py-8">
        <div className="flex items-start justify-between gap-6">
          <div className="flex flex-col">
            <span className="font-serif text-2xl font-black tracking-tight text-foreground leading-none">
              {t("brand.prefix")}<span className="text-[hsl(var(--primary))]">{t("brand.suffix")}</span>
            </span>
            <span className="font-mono text-[9px] uppercase tracking-[0.18em] text-muted-foreground leading-none mt-0.5">
              {t("header.tagline")}
            </span>
          </div>

          <nav className="flex items-center gap-4 flex-wrap justify-end">
            <a
              href="mailto:abouhashisha@icloud.com"
              className="text-xs text-muted-foreground hover:text-foreground transition-colors"
            >
              Contact
            </a>
            <span className="text-border text-xs select-none">·</span>
            <Link
              href="/blog"
              className="text-xs text-muted-foreground hover:text-foreground transition-colors"
            >
              {t("blog.nav")}
            </Link>
            <span className="text-border text-xs select-none">·</span>
            <Link
              href="/legal/privacy"
              className="text-xs text-muted-foreground hover:text-foreground transition-colors"
            >
              {t("footer.privacy")}
            </Link>
            <span className="text-border text-xs select-none">·</span>
            <Link
              href="/legal/terms"
              className="text-xs text-muted-foreground hover:text-foreground transition-colors"
            >
              {t("footer.terms")}
            </Link>
          </nav>
        </div>

      </div>
    </footer>
  );
}
